import { useTranslation } from "react-i18next";

function RoomPlanIcon() {
  return (
    <svg viewBox="0 0 48 40" aria-hidden="true">
      <path d="M3 37V12L13 3h17v10h15v24H3Z" />
      <path d="M30 13h-8v8h8v8h8" />
    </svg>
  );
}

function RoomPlanHeader({ title, description }) {
  const { t } = useTranslation();

  return (
    <header className="room-plan-header">
      <div className="room-plan-header__eyebrow">
        <RoomPlanIcon />
        <span>{t("Room plan setup")}</span>
      </div>
      <h1>{t(title)}</h1>
      <p>{t(description)}</p>
    </header>
  );
}

export default RoomPlanHeader;
